module.exports = __webpack_public_path__ + "media/react/pages/mock_tests/free/brand/logo/assets/nyu_stern_logo-99189f7019fba9ed36a81f1f23f71011.png";